<template>

  <ModalContainer queryParam="gen" ref="modalContainer" size="xl">
    <b-card>
      <h3 class="modal-title mb-1">Informe de la Terapia.</h3>

      <b-row>
        <b-col class="col-12">
          <b-card bg-variant="light" text-variant="dark">
            <b-col class="col-6">
              <b-row class="mb-1">
                <b class="col-4">Paciente: </b>{{ dataTerapia.pacienteNombre }}
              </b-row>


              <b-row class="mb-1">
                <b class="col-4">Nombre de terapia:</b>
                <span class="col-7 p-0">{{ dataTerapia.nombre }}</span>
              </b-row>

              <b-row class="mb-1">
                <b class="col-4">Fecha de sesion:</b>
                <span class="col-7 p-0">{{ dataTerapia.fechaSesion }}</span>
              </b-row>

            </b-col>
              <b-col class="col-6">
              <b-row class="mb-1">
                <b class="col-4">Motivo Solicitud: </b>{{ dataTerapia.motivoSolicitud }}
              </b-row>


              <b-row class="mb-1">
                <b class="col-4">Resumen / Plan Terapeutico:</b>
                <span class="col-7 p-0">{{ dataTerapia.resumenClinico }}</span>
              </b-row>

             

            </b-col>
          </b-card>
        </b-col>

      </b-row>


      <b-tabs>
        <b-tab title="Datos generales">
          <b-card style="border:1px solid #c9c9c9" class="py-2">

          <div class="row">
            <div class="col">
            <b>Detalle de Terapia Realizada:</b>
            <b-form-textarea v-model="terapiaGeneral.detalle"></b-form-textarea>
            </div>
          </div>
          <div class="row">
             <div class="col">
            <b>Conclusiones y Recomendaciones:</b>
            <b-form-textarea v-model="terapiaGeneral.recomendaciones"></b-form-textarea>
            </div>  
          </div>
          <hr/>
           <span><strong>Escoja el tipo de terapista:</strong></span>

           <div class='row'>

    <!-- Radio buttons para escoger Doctor o Auxiliar -->
    <b-form-radio-group
      v-model="tipoTerapista"
      :options="opcionesTerapista"
      buttons
      button-variant="outline-primary"
      class="my-1"
    ></b-form-radio-group>
    </div>

    <!-- Buscar DOCTOR -->
    <b-row v-if="tipoTerapista === 'doctor'" class="my-1">
      <label class="col-2">Doctor:</label>
      <SearchOpts
        class="col-10"
        v-model="terapiaGeneral.terapista"
        :searchService="getDoctoresByEstablecimiento"
        placeholder="Buscar doctor..."
        :minChars="3"
      />
    </b-row>

    <!-- Buscar AUXILIAR -->
    <b-row v-if="tipoTerapista === 'auxiliar'" class="my-1">
      <label class="col-2">Auxiliar:</label>
      <SearchOpts
        class="col-10"
        v-model="terapiaGeneral.terapista"
        :searchService="auxiliarService.searchAuxiliaresByTermSelect"
        placeholder="Buscar auxiliar..."
        :minChars="3"
      />
    </b-row>
          
          </b-card>

        </b-tab>
         <b-tab title="Firma Paciente">
             <ProcessSignature  :base64Signature="dataTerapia.signatureBlob"
            @signatureBlob="firmaRecibida" />
       </b-tab>

      </b-tabs>


      <div class="d-flex justify-content-end">
        <b-button variant="primary" @click="onSaveFormSesion">
          Guardar
        </b-button>
      </div>


    </b-card>
  </ModalContainer>

</template>

<script>
import vSelect from "vue-select";
import { addNewOpt, addUniqueNewOpt } from '@/shared/helpers';
import 'flatpickr/dist/flatpickr.css';
import { sesionesTerapiaService } from "../services";
import SearchOpts from "../../../shared/components/SearchOpts/SearchOpts.vue";
import { doctoresService } from "../../administracion/services";
import { auxiliarService } from "../../../shared/services";
import { getEstablecimientoLS } from "../../../shared/helpers";


import { ModalContainer } from '@/shared/components';
import ProcessSignature from "../../topaz/components/ProcessSignature.vue";

export default {
  name: "FormTerapiaPsicologica",


  components: {
    vSelect,
    ModalContainer,
    ProcessSignature,
    SearchOpts
  },


  data() {
    return {
      tipoTerapista: 'doctor', 
      
      opcionesTerapista: [
        { text: 'Doctor', value: 'doctor' },
        { text: 'Auxiliar', value: 'auxiliar' },
      ],
      auxiliarService,
      doctoresService,
      sesionesTerapiaService,
      tokenSesion: null,
      tokenTerapia: null,

      dataTerapia: {
        pacienteNombre: '',
        nombre: '',
        fechaSesion: '',
        resumenClinico:'',
        motivoSolicitud:'',
        signaturePersona: null,
        signatureBlob: null,
        terapista: null,

      },

      nuevaFirma:"",

  
      terapiaGeneral:{
        detalle:'',
        recomendaciones:'',
        terapista:''
      }

     


    };
  },

  // created() {
  //   this.loadData();
  // },

  watch:{

    '$route.query.gen':
    {
      deep:true,
      immediate:true,
      async handler(newValue){
        if(newValue){

          this.terapiaGeneral = {
        detalle:'',
        recomendaciones:'',
        terapista:''
      }
          this.tokenSesion = newValue;
          await this.loadData()
        }
      }
    }
  },

  methods: {
    async getDoctoresByEstablecimiento(search) {
      const establecimiento = getEstablecimientoLS();
      const responseDoctores = await doctoresService.searchDoctoresByTermSelect(search, establecimiento.id);

      const responseMap = responseDoctores.map(item => ({
        value: item.value,
        text: item.text,
        especialidad: item.especialidad,
        urlFirmaSello: item.urlFirmaSello
      }));

      return responseMap;
    },

    async loadData() {
    
      const dataResponse = await this.sesionesTerapiaService.obtenerDataSesionTerapia(this.tokenSesion)

      const sesionTerapia = dataResponse.sesionTerapia
      const paciente = dataResponse.paciente
      this.dataTerapia.pacienteNombre = `${paciente.persona.primerApellido} ${paciente.persona.primerNombre}`
      this.dataTerapia.nombre = sesionTerapia.solicitudTerapia.terapia.nombre
      this.dataTerapia.fechaSesion = sesionTerapia.fechaSesion
      this.dataTerapia.motivoSolicitud = sesionTerapia.solicitudTerapia.motivoSolicitud
      this.dataTerapia.resumenClinico = sesionTerapia.solicitudTerapia.resumenClinico


      try{
        if(dataResponse){
          
          let dataForm = JSON.parse(dataResponse.sesionTerapia.dataFormulario)
          this.terapiaGeneral = dataForm
         
        }
      }catch(error){
        console.error("error parseo", error)
      }

    },



    async onSaveFormSesion() {


      
      let terapiaGeneral = this.terapiaGeneral
      terapiaGeneral.firmaBlob = this.nuevaFirma
      const jsonDataForm = JSON.stringify(terapiaGeneral)
      const response = await this.sesionesTerapiaService.saveDataSesionTerapia(this.tokenSesion, jsonDataForm)

      if (response) {
        // Cerrar el modal al guardar correctamente
        if (this.$refs.modalContainer && this.$refs.modalContainer.closeModal) {
          await this.$refs.modalContainer.closeModal();
        }
        this.$swal.fire({
          icon: 'success',
          title: 'Datos guardados',
          text: 'La sesión de terapia se guardó correctamente.',
          confirmButtonText: 'Aceptar'
        });

      } else {
        this.$swal.fire({
          icon: 'error',
          title: 'Error al guardar',
          text: 'No se pudo guardar la sesión de terapia. Por favor, intenta de nuevo.',
          confirmButtonText: 'Cerrar'
        });

      }
         // 👉 Emitir al padre que la sesión fue guardada
    this.$emit('sesion-guardada');
    },


    onAddNewOpt(newArray) {
      return addNewOpt(newArray);
    },

    onAddUniqueNewOpt(newArray) {
      return addUniqueNewOpt(newArray);
    },
  }
}
</script>
